import React, { useState } from 'react';
import './ReplyModal.css';

const ReplyModal = ({ review, onClose, onSave }) => {
  const [replyText, setReplyText] = useState('');
  const [error, setError] = useState('');

  const templates = [
    'Thank you for your feedback!',
    'We apologize for the inconvenience.',
    'We\'re glad you enjoyed your meal!'
  ];

  const handleTemplateClick = (template) => {
    setReplyText(template);
  };

  const handleSubmit = () => {
    if (!replyText.trim()) {
      setError('Please enter a response');
      return;
    }
    if (replyText.length > 500) {
      setError('Response must be 500 characters or less');
      return;
    }
    onSave(replyText);
  };

  return (
    <div className="reply-modal-overlay" onClick={onClose}>
      <div className="reply-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Reply to Review</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="review-preview">
          <div className="preview-header">
            <span className="preview-name">{review.customer.name}</span>
            <span className="preview-rating">⭐ {review.rating}.0</span>
          </div>
          <div className="preview-text">
            {review.reviewText.length > 150 
              ? review.reviewText.substring(0, 150) + '...'
              : review.reviewText}
          </div>
        </div>

        <div className="modal-content">
          <label className="form-label">Your Response</label>
          <textarea
            className={`reply-textarea ${error ? 'error' : ''}`}
            value={replyText}
            onChange={(e) => {
              setReplyText(e.target.value);
              setError('');
            }}
            placeholder="Write your response to this review..."
            rows="6"
            maxLength={500}
          />
          {error && <div className="error-message">{error}</div>}
          <div className="char-counter">{replyText.length}/500</div>

          <div className="templates-section">
            <label className="templates-label">Quick Templates</label>
            <div className="templates-buttons">
              {templates.map((template, i) => (
                <button
                  key={i}
                  className="template-btn"
                  onClick={() => handleTemplateClick(template)}
                >
                  {template}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="footer-btn cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="footer-btn save-btn" onClick={handleSubmit}>
            Post Reply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReplyModal;

